// Work in paise. The prepaid offer must leave at least Rs 1 to pay.
export function onlineTotals(subtotal, couponDiscount = 0, offerTitle = "") {
  const remaining = Math.max(0, Math.round(Number(subtotal) * 100) - Math.round(Number(couponDiscount || 0) * 100));
  const isStoreCredit = String(offerTitle || "").trim().replace(/\s+/g, " ").toLowerCase() === "store credit";
  const prepaidDiscount = !isStoreCredit && remaining >= 10100 ? 10000 : 0;
  return { payable: (remaining - prepaidDiscount) / 100, prepaidDiscount: prepaidDiscount / 100 };
}
